import { idleTimeoutMs, LAST_ACTIVITY_KEY } from "./sessionConfig";

const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "wheel",
  "touchstart",
  "scroll"
];

const ACTIVITY_WRITE_THROTTLE_MS = 30 * 1000;
const IDLE_CHECK_INTERVAL_MS = 15 * 1000;

export function markActivity(): void {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
}

export function hasIdledOut(): boolean {
  const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY));

  if (!lastActivity) {
    return false;
  }

  return Date.now() - lastActivity > idleTimeoutMs;
}

// Watches real user interaction, never network traffic, so that background
// requests such as the roadmap auto save cannot keep a session alive.
// Activity is shared through localStorage, so any open tab counts as activity.
export function startIdleWatcher(onIdle: () => void): () => void {
  let lastWriteAt = 0;
  let stopped = false;
  let intervalId = 0;

  const onActivity = () => {
    const now = Date.now();

    if (now - lastWriteAt < ACTIVITY_WRITE_THROTTLE_MS) {
      return;
    }

    lastWriteAt = now;
    markActivity();
  };

  const checkIdle = () => {
    if (stopped || !hasIdledOut()) {
      return;
    }

    stop();
    onIdle();
  };

  const stop = () => {
    if (stopped) {
      return;
    }

    stopped = true;
    window.clearInterval(intervalId);
    ACTIVITY_EVENTS.forEach(eventName =>
      window.removeEventListener(eventName, onActivity)
    );
    document.removeEventListener("visibilitychange", checkIdle);
  };

  ACTIVITY_EVENTS.forEach(eventName =>
    window.addEventListener(eventName, onActivity, { passive: true })
  );
  document.addEventListener("visibilitychange", checkIdle);

  intervalId = window.setInterval(checkIdle, IDLE_CHECK_INTERVAL_MS);

  return stop;
}
